import React, { useState, useEffect } from "react";
import "./Landing.css";
import { useShoppingContext } from "../context/ShoppingContext";
import { useNavigate } from "react-router-dom";

const Landing = () => {
  const {
    isButtonClicked,
    setIsButtonClicked,
    isSignInActive,
    setIsSignInActive,
    isDarkMode,
  } = useShoppingContext();
  const navigate = useNavigate();
  const [textClass, setTextClass] = useState("text-appear");

  // Ejecutar cuando el componente se monte
  useEffect(() => {
    setTextClass("text-appear show-text");
  }, []);

  return (
    <div
      className={isDarkMode ? "content-container" : "content-container light"}
    >
      <div className={isDarkMode ? "landing-content" : "landing-content light"}>
        <h1 className={`landing-title ${textClass}`}>
          Convierte tu Granja en un Imperio avícola
        </h1>
        {/* <p className={`landing-subtitle ${textClass}`}>
          Empieza desde cero o impulsa tu granja actual con tus propios datos.
          ¡La gestión nunca ha sido tan fácil!
        </p> */}
        <div className={`landing-buttons ${textClass}`}>
          <button
            className={`landing-btn start-btn ${
              isButtonClicked ? "clicked" : ""
            }`}
            onClick={() => {
              navigate("/create");
              setIsSignInActive(false);
              setIsButtonClicked(false);
            }}
          >
            Empieza tu Granja
          </button>
          <button
            className={
              isDarkMode
                ? `landing-btn login-btn ${isButtonClicked ? "clicked" : ""}`
                : `landing-btn login-btn light ${
                    isButtonClicked ? "clicked" : ""
                  }`
            }
            onClick={() => {
              navigate("/login");
              console.log(isSignInActive);
            }}
          >
            Inicia Sesión
          </button>
        </div>
        {/* <p className={`landing-p ${textClass}`}>
          ¡Nuestra plataforma es gratuita para todos! Aprende habilidades
          valiosas de{" "}
          <b className={isDarkMode ? "cc-highlight" : "cc-highlight light"}>
            Crianza y Cuidado de Gallinas Ponedoras
          </b>{" "}
          sin costo alguno. Utilizamos un sistema avanzado y personalizado de
          producción agrícola para ofrecerte la mejor experiencia en la gestión
          integral de tu granja.
        </p> */}
      </div>
    </div>
  );
};

export default Landing;
